import { useEffect, useState } from "react";
import "./RolesFormModal.css";

function RolFormModal({ isOpen, onClose, rolData, onSubmit }) {
  const isEdit = !!rolData;

  const [form, setForm] = useState({ nombre: "" });
  const [saving, setSaving] = useState(false);
  const [alert, setAlert] = useState(null);

  const getNiceErrorMessage = (error, fallback = "No se pudo guardar el rol.") => {
    const msg =
      error?.response?.data?.message ||
      error?.message ||
      fallback;

    const clean = String(msg).replace(/\s+/g, " ").trim();
    return clean.length > 220 ? clean.slice(0, 220) + "…" : clean;
  };

  const showAlert = (type, message, ms = 3500) => {
    setAlert({ type, message });
    window.clearTimeout(showAlert._t);
    showAlert._t = window.setTimeout(() => setAlert(null), ms);
  };

  useEffect(() => {
    if (!isOpen) return;

    setForm({ nombre: rolData?.nombre || "" });
    setAlert(null);
    setSaving(false);
  }, [isOpen, rolData]);

  useEffect(() => {
    if (!isOpen) return;

    const handler = (e) => {
      if (e.key === "Escape") onClose?.();
    };

    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [isOpen, onClose]);

  const updateField = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const submit = async (e) => {
    e.preventDefault();
    setAlert(null);

    const nombre = String(form.nombre || "").trim();
    if (!nombre) {
      showAlert("error", "El nombre del rol es obligatorio.");
      return;
    }

    setSaving(true);
    try {
      await onSubmit({ nombre });
      showAlert("success", isEdit ? "Rol actualizado correctamente." : "Rol creado correctamente.");
      window.setTimeout(() => onClose?.(), 650);
    } catch (error) {
      console.error("Error al guardar el rol:", error);
      showAlert("error", getNiceErrorMessage(error));
    } finally {
      setSaving(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div
      className="tienda-modal__overlay"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose?.();
      }}
    >
      <div className="tienda-modal tienda-modal--shell" onMouseDown={(e) => e.stopPropagation()}>
        <div className="tienda-modal__header">
          <div className="tienda-modal__header-text">
            <h2 className="tienda-modal__title">{isEdit ? "Editar rol" : "Crear rol"}</h2>
            <p className="tienda-modal__subtitle">
              {isEdit ? "Modifica el nombre del rol." : "Define un nuevo rol para asignar permisos."}
            </p>
          </div>
          <button type="button" className="tienda-modal__close" onClick={onClose} title="Cerrar">✕</button>
        </div>

        {alert && (
          <div
            className={`tienda-modal__alert tienda-modal__alert--${
              alert.type === "error" ? "error" : alert.type === "success" ? "success" : "info"
            }`}
          >
            <span>{alert.message}</span>
            <button type="button" className="tienda-modal__alert-x" onClick={() => setAlert(null)}>✕</button>
          </div>
        )}

        <form onSubmit={submit} className="tienda-modal__body">
          <div className="tienda-modal__field">
            <label className="tienda-modal__label">Nombre del rol</label>
            <input
              name="nombre"
              value={form.nombre}
              onChange={updateField}
              required
              className="tienda-modal__input"
              placeholder="Ingresa el nombre del rol"
              disabled={saving}
              autoFocus
            />
          </div>

          <div className="tienda-modal__footer">
            <button type="button" onClick={onClose} className="tienda-modal__btn tienda-modal__btn--secondary" disabled={saving}>
              Cancelar
            </button>
            <button type="submit" className="tienda-modal__btn tienda-modal__btn--primary" disabled={saving}>
              {saving ? "Guardando…" : isEdit ? "Guardar cambios" : "Crear rol"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default RolFormModal;
